import { render, staticRenderFns } from "./BitvilleButton.vue?vue&type=template&id=2afd3c2a"
import script from "./BitvilleButton.vue?vue&type=script&lang=ts"
export * from "./BitvilleButton.vue?vue&type=script&lang=ts"
import style0 from "./BitvilleButton.vue?vue&type=style&index=0&id=2afd3c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports